export default __webpack_public_path__ + "static/media/debug.32d43490.png";